/**
 * iter-386u-b — Quality Tier badge.
 *
 * Small colored pill next to a BOQ line item's title. Renders one of
 * [B] Budget · [S] Standard · [P] Premium · [L] Luxury.
 * Used on the Edit BOQ page and both public shareable views
 * (vendor-quote and public-BOQ) so the tag stays identical everywhere.
 */

const _TIER_META = {
  budget: { letter: 'B', label: 'Budget', bg: '#eef2ff', fg: '#3730a3', border: '#c7d2fe' },
  standard: { letter: 'S', label: 'Standard', bg: '#ecfdf5', fg: '#065f46', border: '#a7f3d0' },
  premium: { letter: 'P', label: 'Premium', bg: '#fff7ed', fg: '#9a3412', border: '#fed7aa' },
  luxury: { letter: 'L', label: 'Luxury', bg: '#faf5ff', fg: '#6b21a8', border: '#e9d5ff' },
};

export default function QualityTierBadge({ tier, size = 'sm', showLabel = false, className = '' }) {
  const key = (tier || '').toString().toLowerCase();
  const meta = _TIER_META[key];
  if (!meta) return null;
  const px = size === 'xs' ? '2px 6px' : size === 'md' ? '4px 10px' : '3px 8px';
  const fs = size === 'xs' ? 9 : size === 'md' ? 12 : 10;
  return (
    <span
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-wide align-middle ${className}`}
      style={{
        background: meta.bg,
        color: meta.fg,
        border: `1px solid ${meta.border}`,
        padding: px,
        fontSize: fs,
        lineHeight: 1.1,
      }}
      title={`Quality Tier: ${meta.label}`}
      data-testid={`quality-tier-badge-${key}`}
    >
      [{meta.letter}]{showLabel ? ` ${meta.label}` : ''}
    </span>
  );
}
